import CategoryType from './CategoryType';

export default CategoryType;
